// extracted by mini-css-extract-plugin
export var productImage = "_pk-1";
export var viewLink = "_pk-2";
export var wishlistItem = "_pk-0";